export function AppSection() {
  return (
    <section id="app" className="py-10 md:py-14 bg-accent-50/60">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-8 max-w-4xl mx-auto">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">移动追更</h2>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-md mx-auto lg:mx-0">
              关注韩漫屋微信公众号，随时随地接收韩漫最新更新提醒。支持在手机上浏览全部追更内容，让韩漫追更不再受时间和地点限制。
            </p>
            <div className="mt-5 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-950 text-background-50 font-medium text-sm cursor-pointer hover:bg-foreground-800 transition-colors">
                <i className="ri-smartphone-line"></i>
                微信公众号关注
              </button>
              <button className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-secondary-300 text-foreground-700 font-medium text-sm cursor-pointer hover:border-primary-400 hover:text-primary-600 transition-colors">
                <i className="ri-qr-code-line"></i>
                扫码关注
              </button>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="w-40 h-40 rounded-2xl bg-background-50 border-2 border-accent-200 flex items-center justify-center">
              <div className="text-center">
                <i className="ri-wechat-line text-accent-500 text-4xl"></i>
                <p className="mt-2 text-xs text-foreground-500 font-medium">韩漫屋追更</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function AboutSection() {
  return (
    <section id="about" className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">关于韩漫屋</h2>
        <div className="mt-5 text-sm text-foreground-600 leading-relaxed space-y-4 text-left">
          <p>
            韩漫屋是专注于韩漫追更服务的信息聚合平台，致力于为韩漫爱好者提供最快、最全的韩漫最新更新信息。
            我们追踪全网热门韩漫作品，实时推送韩漫连载更新提醒，让每一位追更读者都能第一时间获取最新章节动态。
          </p>
          <p>
            平台自上线以来，已收录超过2,000部韩漫作品，涵盖恋爱甜宠、奇幻冒险、异世穿越、复仇逆袭、校园青春、
            悬疑推理、BL纯爱、动作热血、都市职场等多种题材。我们坚持完全免费的原则，读者无需注册登录即可浏览全部更新内容。
          </p>
          <p>
            韩漫屋团队由一群热爱韩漫的资深读者组成，我们理解追更等待的焦急心情，因此打造了这个高效、便捷的追更平台。
            未来我们将持续优化更新速度，扩充作品覆盖范围，为韩漫社区提供更优质的服务。
          </p>
        </div>
      </div>
    </section>
  );
}

const indexItems = [
  { label: '恋爱甜宠', icon: 'ri-heart-line', count: '1,286', desc: '甜蜜浪漫爱情故事' },
  { label: '奇幻冒险', icon: 'ri-magic-line', count: '958', desc: '异世界奇幻旅程' },
  { label: '异世穿越', icon: 'ri-rocket-line', count: '873', desc: '穿越时空的冒险' },
  { label: '复仇逆袭', icon: 'ri-sword-line', count: '742', desc: '逆袭反转爽文' },
  { label: '校园青春', icon: 'ri-school-line', count: '1,102', desc: '青春校园物语' },
  { label: '悬疑推理', icon: 'ri-search-eye-line', count: '617', desc: '烧脑悬疑故事' },
  { label: 'BL纯爱', icon: 'ri-heart-2-line', count: '1,456', desc: '纯爱BL佳作' },
  { label: '动作热血', icon: 'ri-fire-line', count: '831', desc: '热血战斗漫画' },
  { label: '都市职场', icon: 'ri-building-line', count: '584', desc: '都市职场人生' },
];

export function IndexSection() {
  return (
    <section id="index" className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">主题索引</h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">按题材分类浏览全部韩漫作品</p>
        <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
          {indexItems.map((item) => (
            <div key={item.label} className="p-4 rounded-xl bg-background-100 border border-background-200/70 text-center cursor-pointer hover:border-primary-200/70 transition-colors group">
              <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-lg bg-primary-100">
                <i className={`${item.icon} text-primary-600 text-lg`}></i>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">{item.label}</h3>
              <p className="mt-1 text-xs text-foreground-500">{item.count} 部作品</p>
              <p className="mt-1 text-xs text-foreground-400">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const carouselItems = [
  {
    title: '恋爱甜宠专题',
    subtitle: '高甜恋爱韩漫精选合集',
    desc: '从校园初恋到职场恋爱，精选最甜的韩漫恋爱故事，每周更新推荐榜单。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20royal%20palace%20scenery%20with%20soft%20watercolor%20style%2C%20Korean%20manhwa%20aesthetic%2C%20romantic%20historical%20setting%2C%20warm%20golden%20and%20rose%20tones%2C%20detailed%20architectural%20elements%2C%20dreamy%20atmosphere%2C%20beautiful%20composition&width=600&height=400&seq=carousel-01&orientation=landscape',
  },
  {
    title: '奇幻冒险精选',
    subtitle: '异世界奇幻韩漫推荐',
    desc: '穿越异世界、魔法与剑，最热门的韩漫奇幻冒险故事一网打尽。',
    img: 'https://readdy.ai/api/search-image?query=Enchanted%20fantasy%20forest%20with%20glowing%20magical%20elements%2C%20Korean%20webtoon%20style%2C%20ethereal%20atmosphere%2C%20soft%20mint%20and%20lavender%20tones%20with%20warm%20highlights%2C%20mystical%20creatures%2C%20high%20detail%2C%20dreamy%20scene&width=600&height=400&seq=carousel-02&orientation=landscape',
  },
  {
    title: '复仇逆袭合集',
    subtitle: '反转人生爽文韩漫',
    desc: '主角逆袭反转、打脸虐渣的韩漫爽文合集，每部都让人欲罢不能。',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20Korean%20manhwa%20scene%20of%20a%20powerful%20female%20character%20in%20elegant%20attire%2C%20intense%20expression%2C%20warm%20gold%20and%20deep%20crimson%20tones%2C%20palace%20background%2C%20dynamic%20composition%2C%20high%20contrast%2C%20cinematic&width=600&height=400&seq=carousel-03&orientation=landscape',
  },
  {
    title: 'BL纯爱殿堂',
    subtitle: '高人气BL韩漫特辑',
    desc: '精选口碑最佳的BL纯爱韩漫，细腻情感描绘，触动心弦的故事。',
    img: 'https://readdy.ai/api/search-image?query=Two%20male%20characters%20in%20Korean%20manhwa%20art%20style%20in%20a%20cozy%20cafe%20setting%2C%20warm%20ambient%20lighting%2C%20soft%20coral%20and%20cream%20tones%2C%20intimate%20atmosphere%2C%20beautiful%20composition%2C%20emotional%20moment&width=600&height=400&seq=carousel-04&orientation=landscape',
  },
  {
    title: '悬疑推理剧场',
    subtitle: '烧脑悬疑韩漫推荐',
    desc: '层层反转的韩漫悬疑推理故事，每一话都埋下精彩伏笔，让人停不下来。',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20library%20at%20night%20in%20Korean%20manhwa%20art%20style%2C%20dramatic%20shadows%20and%20warm%20lamp%20glow%2C%20noir%20atmosphere%2C%20intriguing%20composition%2C%20soft%20amber%20and%20deep%20brown%20tones%2C%20high%20detail&width=600&height=400&seq=carousel-05&orientation=landscape',
  },
];

export function CarouselSection() {
  return (
    <section id="carousel" className="py-10 md:py-14 bg-secondary-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">焦点专题</h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">精选热门韩漫专题合集，一站式追更体验</p>
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.slice(0, 3).map((item) => (
            <div key={item.title} className="rounded-xl overflow-hidden bg-background-50 border border-background-200/70 cursor-pointer group">
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img src={item.img} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <p className="text-xs text-background-50/80">{item.subtitle}</p>
                  <h3 className="text-base font-semibold text-background-50 mt-1">{item.title}</h3>
                </div>
              </div>
              <div className="p-4">
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-5">
          {carouselItems.slice(3).map((item) => (
            <div key={item.title} className="flex gap-4 rounded-xl overflow-hidden bg-background-50 border border-background-200/70 cursor-pointer group">
              <div className="w-40 h-28 flex-shrink-0 overflow-hidden bg-background-200">
                <img src={item.img} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="flex-1 flex flex-col justify-center p-3 min-w-0">
                <p className="text-xs text-foreground-500">{item.subtitle}</p>
                <h3 className="text-sm font-semibold text-foreground-900 mt-1">{item.title}</h3>
                <p className="mt-1 text-xs text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const comments = [
  {
    name: '追更小达人',
    text: '韩漫屋真的是我用过最好用的韩漫追更平台！每5分钟自动刷新一次更新，再也不用一个个网站去找最新章节了。特别推荐恋爱甜宠专区，我的最爱！',
    time: '3天前',
    avatar: 'ri-user-3-line',
  },
  {
    name: '漫画控阿星',
    text: '从朋友那里知道韩漫屋的，用了快半年了。更新速度真的快，我独自升级每次更新我都是在这里第一时间看到的。完全免费这点太良心了，韩漫连载更新提醒太方便了！',
    time: '5天前',
    avatar: 'ri-user-4-line',
  },
  {
    name: '每天追更的小米',
    text: '关注韩漫屋的微信公众号之后，推送特别及时。BL纯爱区的收录太全了，好多小众好作品都能在这里找到。强烈推荐给所有韩漫爱好者！',
    time: '1周前',
    avatar: 'ri-user-5-line',
  },
];

export function CommentsSection() {
  return (
    <section id="comments" className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">读者评论</h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">来自韩漫追更读者的真实反馈</p>
        <div className="mt-6 grid grid-cols-1 gap-4">
          {comments.map((item) => (
            <div key={item.name} className="p-5 rounded-xl bg-background-50 border border-background-200/70">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100">
                  <i className={`${item.avatar} text-secondary-600 text-lg`}></i>
                </div>
                <div>
                  <span className="block text-sm font-semibold text-foreground-900">{item.name}</span>
                  <span className="text-xs text-foreground-500">{item.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}